/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppReleaseChannelPointerDto } from '../models/app-release-channel-pointer-dto';
import { appReleaseControllerCreate } from '../fn/app-release/app-release-controller-create';
import { AppReleaseControllerCreate$Params } from '../fn/app-release/app-release-controller-create';
import { appReleaseControllerDownloadCurrentChannelAsset } from '../fn/app-release/app-release-controller-download-current-channel-asset';
import { AppReleaseControllerDownloadCurrentChannelAsset$Params } from '../fn/app-release/app-release-controller-download-current-channel-asset';
import { appReleaseControllerDownloadCurrentChannelFeed } from '../fn/app-release/app-release-controller-download-current-channel-feed';
import { AppReleaseControllerDownloadCurrentChannelFeed$Params } from '../fn/app-release/app-release-controller-download-current-channel-feed';
import { appReleaseControllerDownloadCurrentChannelFeedFromBasePath } from '../fn/app-release/app-release-controller-download-current-channel-feed-from-base-path';
import { AppReleaseControllerDownloadCurrentChannelFeedFromBasePath$Params } from '../fn/app-release/app-release-controller-download-current-channel-feed-from-base-path';
import { appReleaseControllerFindAll } from '../fn/app-release/app-release-controller-find-all';
import { AppReleaseControllerFindAll$Params } from '../fn/app-release/app-release-controller-find-all';
import { appReleaseControllerFindById } from '../fn/app-release/app-release-controller-find-by-id';
import { AppReleaseControllerFindById$Params } from '../fn/app-release/app-release-controller-find-by-id';
import { appReleaseControllerFindCurrentChannelRelease } from '../fn/app-release/app-release-controller-find-current-channel-release';
import { AppReleaseControllerFindCurrentChannelRelease$Params } from '../fn/app-release/app-release-controller-find-current-channel-release';
import { appReleaseControllerPublish } from '../fn/app-release/app-release-controller-publish';
import { AppReleaseControllerPublish$Params } from '../fn/app-release/app-release-controller-publish';
import { appReleaseControllerRollback } from '../fn/app-release/app-release-controller-rollback';
import { AppReleaseControllerRollback$Params } from '../fn/app-release/app-release-controller-rollback';
import { appReleaseControllerUploadAsset } from '../fn/app-release/app-release-controller-upload-asset';
import { AppReleaseControllerUploadAsset$Params } from '../fn/app-release/app-release-controller-upload-asset';
import { AppReleaseDto } from '../models/app-release-dto';

@Injectable({ providedIn: 'root' })
export class AppReleaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appReleaseControllerDownloadCurrentChannelFeedFromBasePath()` */
  static readonly AppReleaseControllerDownloadCurrentChannelFeedFromBasePathPath = '/api/app-releases/channels/current/{channel}/{platform}/{arch}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerDownloadCurrentChannelFeedFromBasePath()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerDownloadCurrentChannelFeedFromBasePath$Response(params: AppReleaseControllerDownloadCurrentChannelFeedFromBasePath$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appReleaseControllerDownloadCurrentChannelFeedFromBasePath(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerDownloadCurrentChannelFeedFromBasePath$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerDownloadCurrentChannelFeedFromBasePath(params: AppReleaseControllerDownloadCurrentChannelFeedFromBasePath$Params, context?: HttpContext): Observable<void> {
    return this.appReleaseControllerDownloadCurrentChannelFeedFromBasePath$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerDownloadCurrentChannelFeed()` */
  static readonly AppReleaseControllerDownloadCurrentChannelFeedPath = '/api/app-releases/channels/current/{channel}/{platform}/{arch}/latest.yml';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerDownloadCurrentChannelFeed()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerDownloadCurrentChannelFeed$Response(params: AppReleaseControllerDownloadCurrentChannelFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appReleaseControllerDownloadCurrentChannelFeed(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerDownloadCurrentChannelFeed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerDownloadCurrentChannelFeed(params: AppReleaseControllerDownloadCurrentChannelFeed$Params, context?: HttpContext): Observable<void> {
    return this.appReleaseControllerDownloadCurrentChannelFeed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerDownloadCurrentChannelAsset()` */
  static readonly AppReleaseControllerDownloadCurrentChannelAssetPath = '/api/app-releases/channels/current/{channel}/{platform}/{arch}/assets/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerDownloadCurrentChannelAsset()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerDownloadCurrentChannelAsset$Response(params: AppReleaseControllerDownloadCurrentChannelAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appReleaseControllerDownloadCurrentChannelAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerDownloadCurrentChannelAsset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerDownloadCurrentChannelAsset(params: AppReleaseControllerDownloadCurrentChannelAsset$Params, context?: HttpContext): Observable<void> {
    return this.appReleaseControllerDownloadCurrentChannelAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerFindCurrentChannelRelease()` */
  static readonly AppReleaseControllerFindCurrentChannelReleasePath = '/api/app-releases/channels/current';

  /**
   * Get current channel release.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerFindCurrentChannelRelease()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerFindCurrentChannelRelease$Response(params?: AppReleaseControllerFindCurrentChannelRelease$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseChannelPointerDto>> {
    return appReleaseControllerFindCurrentChannelRelease(this.http, this.rootUrl, params, context);
  }

  /**
   * Get current channel release.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerFindCurrentChannelRelease$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerFindCurrentChannelRelease(params?: AppReleaseControllerFindCurrentChannelRelease$Params, context?: HttpContext): Observable<AppReleaseChannelPointerDto> {
    return this.appReleaseControllerFindCurrentChannelRelease$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppReleaseChannelPointerDto>): AppReleaseChannelPointerDto => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerFindAll()` */
  static readonly AppReleaseControllerFindAllPath = '/api/app-releases';

  /**
   * List app releases.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerFindAll$Response(params?: AppReleaseControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppReleaseDto>>> {
    return appReleaseControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * List app releases.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerFindAll(params?: AppReleaseControllerFindAll$Params, context?: HttpContext): Observable<Array<AppReleaseDto>> {
    return this.appReleaseControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AppReleaseDto>>): Array<AppReleaseDto> => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerCreate()` */
  static readonly AppReleaseControllerCreatePath = '/api/app-releases';

  /**
   * Create app release.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appReleaseControllerCreate$Response(params: AppReleaseControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
    return appReleaseControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create app release.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appReleaseControllerCreate(params: AppReleaseControllerCreate$Params, context?: HttpContext): Observable<AppReleaseDto> {
    return this.appReleaseControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppReleaseDto>): AppReleaseDto => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerFindById()` */
  static readonly AppReleaseControllerFindByIdPath = '/api/app-releases/{id}';

  /**
   * Get app release detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerFindById$Response(params: AppReleaseControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
    return appReleaseControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get app release detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appReleaseControllerFindById(params: AppReleaseControllerFindById$Params, context?: HttpContext): Observable<AppReleaseDto> {
    return this.appReleaseControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppReleaseDto>): AppReleaseDto => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerUploadAsset()` */
  static readonly AppReleaseControllerUploadAssetPath = '/api/app-releases/{id}/assets/{kind}';

  /**
   * Upload app release asset.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerUploadAsset()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  appReleaseControllerUploadAsset$Response(params: AppReleaseControllerUploadAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
    return appReleaseControllerUploadAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload app release asset.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerUploadAsset$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  appReleaseControllerUploadAsset(params: AppReleaseControllerUploadAsset$Params, context?: HttpContext): Observable<AppReleaseDto> {
    return this.appReleaseControllerUploadAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppReleaseDto>): AppReleaseDto => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerPublish()` */
  static readonly AppReleaseControllerPublishPath = '/api/app-releases/{id}/publish';

  /**
   * Publish app release.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerPublish()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appReleaseControllerPublish$Response(params: AppReleaseControllerPublish$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
    return appReleaseControllerPublish(this.http, this.rootUrl, params, context);
  }

  /**
   * Publish app release.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerPublish$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appReleaseControllerPublish(params: AppReleaseControllerPublish$Params, context?: HttpContext): Observable<AppReleaseDto> {
    return this.appReleaseControllerPublish$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppReleaseDto>): AppReleaseDto => r.body)
    );
  }

  /** Path part for operation `appReleaseControllerRollback()` */
  static readonly AppReleaseControllerRollbackPath = '/api/app-releases/{id}/rollback';

  /**
   * Rollback app release.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appReleaseControllerRollback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appReleaseControllerRollback$Response(params: AppReleaseControllerRollback$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
    return appReleaseControllerRollback(this.http, this.rootUrl, params, context);
  }

  /**
   * Rollback app release.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appReleaseControllerRollback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appReleaseControllerRollback(params: AppReleaseControllerRollback$Params, context?: HttpContext): Observable<AppReleaseDto> {
    return this.appReleaseControllerRollback$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppReleaseDto>): AppReleaseDto => r.body)
    );
  }

}
